const validatemembershipFeesFrom = (data) => {
    let errors = {};
  
    if (!data.feesAmount) {
      errors.feesAmount = 'Fees amount is required';
    } else if (isNaN(data.feesAmount)) {
      errors.feesAmount = 'Fees amount must be a number';
    }
  
    if (!data.membershipTypeId) {
      errors.membershipTypeId = 'Membership type is required';
    }
  
    return errors;
  };
  

  export default validatemembershipFeesFrom;